import React from "react";
import { motion } from "framer-motion";

export default function HowItWorks(){
  const steps = [
    { num: "1", title: "Install & allow SMS access", desc: "Offline parsing only reads transaction SMS for spends."},
    { num: "2", title: "Auto-categorize", desc: "See your spends grouped and searchable."},
    { num: "3", title: "Budget & save", desc: "Get nudges, AI tips and track goals."},
  ];

  return (
    <section id="how" className="py-10 bg-gray-50 dark:bg-[#031025]">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold">How it works — 3 steps</h3>
        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {steps.map((s, idx) => (
            <motion.div
              key={idx}
              initial={{opacity:0, y:12}}
              whileInView={{opacity:1, y:0}}
              viewport={{once:true}}
              transition={{delay: idx * 0.08, duration: 0.45}}
              className="p-6 rounded-2xl bg-gradient-to-br from-white to-gray-50 dark:from-[#041027] dark:to-[#071026] border border-gray-100 dark:border-gray-800 shadow neon-hover"
            >
              <div className="text-3xl font-bold">{s.num}</div>
              <h4 className="mt-3 font-semibold">{s.title}</h4>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{s.desc}</p>
              <div className="mt-4">
                <button className="px-3 py-2 rounded-full border border-transparent hover:border-[#06b6d4] hover:text-[#06b6d4] transition">Try step</button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
